// preventive care test
export const BREED_PREVENTIVE_RULES = {
    "Golden Retriever": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Wellness Exam", "Blood Test", "Flea/Heartworm Prevention"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test", "Flea/Heartworm Prevention"]
        }
    },
    "French Bulldog": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Flea/Heartworm Prevention"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Labrador Retriever": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Deworming"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Small Mix (up to 10 pounds)": {
        puppy: {
            sections: ["procedures"],
            items: ["Fecal Test", "Deworming"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Small Mix (11-25 pounds)": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Fecal Test"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Urinalysis"]
        }
    },
    "Medium Mix (26-50 pounds)": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Fecal Test"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Large Mix (51-100 pounds)": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Deworming"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Domestic Shorthair": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Fecal Test"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Domestic Mediumhair": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Deworming"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Blood Test"]
        }
    },
    "Domestic Longhair": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Fecal Test"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Wellness Exam", "Urinalysis"]
        }
    },
    "American Shorthair": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Wellness Exam"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Blood Test", "Urinalysis"]
        }
    },
    "Mixed Cat": {
        puppy: {
            sections: ["procedures", "vaccines_titers"],
            items: ["Deworming"]
        },
        adult: {
            sections: ["procedures"],
            items: ["Blood Test", "Wellness Exam"]
        }
    }
};

export const BREED_PREVENTIVE_METADATA = {
    "Golden Retriever": {
        puppy: {
            disclaimer:
                "Golden Retrievers are prone to cancer and skin allergies. Platinum includes wellness exams to check for lumps, blood tests to catch allergy triggers, and flea prevention to reduce skin flare-ups. Plus, puppies need spay/neuter and additional vaccines.",
            sources: [
                { label: "AAHA", url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/" },
                {
                    label: "Cornell Veterinary",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/canine-health-information/periodontal-disease"
                },
                { label: "Morris Animal Foundation", url: "https://www.morrisanimalfoundation.org/article/5-common-cancers-in-dogs" },
                { label: "PMC", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10874193/" },
                { label: "VCA Hospitals", url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs" },
                { label: "Wiley", url: "https://onlinelibrary.wiley.com/doi/10.1111/vde.13210" }
            ]
        },
        adult: {
            disclaimer:
                "Golden Retrievers are prone to cancer, skin allergies and hypothyroidism. Platinum includes wellness exams to check for lumps, blood tests to catch allergy triggers and thyroid issues, and flea prevention to reduce skin flare-ups. Plus, adult dogs need regular teeth cleaning to protect from periodontal disease, which can affect their heart, liver, and kidneys.",
            sources: [
                { label: "AAHA", url: "https://www.aaha.org/resources/spay-or-neuter/" },
                {
                    label: "Cornell Veterinary",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/canine-health-information/periodontal-disease"
                },
                { label: "Morris Animal Foundation", url: "https://www.morrisanimalfoundation.org/article/5-common-cancers-in-dogs" },
                { label: "PMC", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10874193/" },
                { label: "VCA Hospitals", url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs" },
                { label: "Wiley", url: "https://onlinelibrary.wiley.com/doi/10.1111/vde.13210" }
            ]
        }
    },
    "French Bulldog": {
        puppy: {
            disclaimer:
                "52% of French Bulldogs develop allergies, and symptoms often start in the first year. Spaying/neutering is recommended in year one, flea prevention reduces skin flare-ups in this allergy-prone breed, and core vaccines protect against distemper and parvovirus.",
            sources: [
                { label: "Springer Nature 2025 (French Bulldog allergy prevalence 52%)", url: "https://link.springer.com/article/10.1186/s13028-025-00789-x" },
                {
                    label: "PMC (atopic dermatitis breed predisposition)",
                    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10874193/"
                },
                { label: "AAHA 2022 Canine Vaccination Guidelines", url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/" }
            ]
        },
        adult: {
            disclaimer:
                "52% of French Bulldogs are affected by allergies, and skin conditions tend to worsen with age. Dental cleanings prevent periodontal disease, blood tests screen for allergy triggers and organ function, and wellness exams catch breathing and skin issues early.",
            sources: [
                { label: "Springer Nature 2025 (French Bulldog allergy prevalence 52%)", url: "https://link.springer.com/article/10.1186/s13028-025-00789-x" },
                {
                    label: "Wiley (canine atopic dermatitis)",
                    url: "https://onlinelibrary.wiley.com/doi/10.1111/vde.13210"
                },
                {
                    label: "Cornell Veterinary (periodontal disease)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease/"
                }
            ]
        }
    },
    "Labrador Retriever": {
        puppy: {
            disclaimer:
                "Labradors are one of the most obesity-prone breeds, and weight habits start early. Spaying/neutering is recommended in year one, core vaccines protect against distemper and parvovirus, and deworming is critical since puppies are routinely exposed to intestinal parasites.",
            sources: [
                { label: "AKC (hypothyroidism in dogs)", url: "https://www.akc.org/expert-advice/health/hypothyroidism-in-dogs/" },
                {
                    label: "AAHA 2022 Canine Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/"
                },
                { label: "CAPC (deworming guidelines)", url: "https://capcvet.org/guidelines/general-guidelines/" }
            ]
        },
        adult: {
            disclaimer:
                "Labradors are highly prone to obesity, ear infections, and joint problems. Dental cleanings prevent periodontal disease that can damage organs, wellness exams monitor weight and mobility, and blood tests screen for thyroid issues Labs are predisposed to.",
            sources: [
                {
                    label: "Cornell Veterinary (periodontal disease)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                },
                {
                    label: "VCA Hospitals (dental disease)",
                    url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs"
                },
                {
                    label: "AKC (hypothyroidism in dogs)",
                    url: "https://www.akc.org/expert-advice/health/hypothyroidism-in-dogs"
                }
            ]
        }
    },
    "Small Mix (up to 10 pounds)": {
        puppy: {
            disclaimer:
                "Dogs under 10 lbs are 5x more likely to develop periodontal disease, and dental issues can start early. Spaying/neutering is recommended in year one, and deworming plus fecal tests are critical since small puppies are especially vulnerable to intestinal parasites.",
            sources: [
                { label: "ScienceDirect/WALTHAM 2021 (small dogs 5x periodontal disease risk)", url: "https://www.sciencedirect.com/science/article/pii/S0167587721002178" },
                {
                    label: "CAPC (deworming guidelines)",
                    url: "https://capcvet.org/guidelines/general-guidelines/"
                },
                { label: "CAPC (fecal testing 4x in first year)", url: "https://www.petsandparasites.org/resources/capc-guidelines" }
            ]
        },
        adult: {
            disclaimer:
                "Dogs under 10 lbs are 5x more likely to develop periodontal disease, which can damage the heart, liver, and kidneys. Regular dental cleanings are critical for small breeds, and blood tests and wellness exams catch hidden organ and metabolic issues early.",
            sources: [
                {
                    label: "ScienceDirect/WALTHAM 2021 (small dogs 5x periodontal disease risk)",
                    url: "https://www.sciencedirect.com/science/article/pii/S0167587721002178"
                },
                {
                    label: "Cornell Veterinary (periodontal disease systemic effects)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                },
                {
                    label: "VCA Hospitals (dental disease)",
                    url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs"
                }
            ]
        }
    },
    "Small Mix (11-25 pounds)": {
        puppy: {
            disclaimer:
                "Small dogs have elevated risk of periodontal disease compared to larger breeds, and dental issues can start in the first two years. Spaying/neutering is recommended in year one, core vaccines protect against serious diseases, and fecal tests catch parasites early.",
            sources: [
                { label: "ScienceDirect/WALTHAM 2021 (small dog dental disease risk)", url: "https://www.sciencedirect.com/science/article/pii/S0167587721002178" },
                {
                    label: "AAHA 2022 Canine Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/"
                },
                { label: "CAPC (fecal testing guidelines)", url: "https://capcvet.org/guidelines/general-guidelines/" }
            ]
        },
        adult: {
            disclaimer:
                "Small dogs have elevated risk of periodontal disease, and untreated dental disease can lead to systemic issues affecting the heart, liver, and kidneys. Wellness exams monitor weight and detect early problems, and urinalysis screens for kidney and urinary tract issues common in smaller breeds.",
            sources: [
                {
                    label: "ScienceDirect/WALTHAM 2021 (small dogs 5x periodontal disease risk)",
                    url: "https://www.sciencedirect.com/science/article/pii/S0167587721002178"
                },
                {
                    label: "Cornell Veterinary (periodontal disease systemic effects)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                },
                {
                    label: "VCA Hospitals (dental disease)",
                    url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs"
                }
            ]
        }
    },
    "Medium Mix (26-50 pounds)": {
        puppy: {
            disclaimer:
                "80% of dogs show signs of periodontal disease by age 3, so early dental care matters. Spaying/neutering is recommended in year one, core vaccines protect against distemper and parvovirus, and fecal tests catch intestinal parasites that are common in puppies.",
            sources: [
                {
                    label: "Cornell Veterinary (80% periodontal disease by age 3)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                },
                {
                    label: "AAHA 2022 Canine Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/"
                },
                { label: "CAPC (fecal testing guidelines)", url: "https://capcvet.org/guidelines/general-guidelines/" }
            ]
        },
        adult: {
            disclaimer:
                "80% of dogs show signs of periodontal disease by age 3, which can damage the heart, liver, and kidneys. Regular wellness exams and blood tests help detect obesity, diabetes, and organ issues before they become serious.",
            sources: [
                {
                    label: "Cornell Veterinary (80% periodontal disease by age 3)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                },
                {
                    label: "VCA Hospitals (dental disease systemic effects)",
                    url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs"
                },
                {
                    label: "AAHA (preventive care guidelines)",
                    url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/"
                }
            ]
        }
    },
    "Large Mix (51-100 pounds)": {
        puppy: {
            disclaimer:
                "Large-breed puppies grow rapidly and are prone to joint and weight issues that start early. Spaying/neutering is recommended in year one, core vaccines protect against serious diseases, and deworming is critical since large puppies are often heavily exposed to intestinal parasites.",
            sources: [
                {
                    label: "AAHA 2022 Canine Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/"
                },
                {
                    label: "CAPC (deworming guidelines)",
                    url: "https://capcvet.org/guidelines/general-guidelines/"
                },
                {
                    label: "Cornell Veterinary (periodontal disease)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                }
            ]
        },
        adult: {
            disclaimer:
                "Large dogs are prone to joint problems and obesity-related conditions that shorten lifespan. Dental cleanings prevent periodontal disease linked to organ damage, wellness exams monitor weight and mobility, and blood tests screen for organ function and metabolic issues.",
            sources: [
                {
                    label: "Cornell Veterinary (periodontal disease)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/riney-canine-health-center/health-topics/canine-health-information/periodontal-disease"
                },
                {
                    label: "VCA Hospitals (dental disease)",
                    url: "https://vcahospitals.com/know-your-pet/dental-disease-in-dogs"
                },
                {
                    label: "AAHA (preventive care)",
                    url: "https://www.aaha.org/resources/2022-aaha-canine-vaccination-guidelines/"
                }
            ]
        }
    },
    "Domestic Shorthair": {
        puppy: {
            disclaimer:
                "Over 60% of U.S. cats are overweight, and spaying/neutering in the first year helps prevent obesity and reproductive cancers. Core FVRCP vaccines protect against rhinotracheitis, calicivirus, and panleukopenia, and fecal tests catch intestinal parasites common in kittens.",
            sources: [
                {
                    label: "APOP 2022 (61% of cats overweight/obese)",
                    url: "https://www.petobesityprevention.org/2022"
                },
                {
                    label: "AAHA/AAFP 2020 Feline Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2020-aahaaafp-feline-vaccination-guidelines/"
                },
                {
                    label: "CAPC (fecal testing guidelines)",
                    url: "https://capcvet.org/guidelines/general-guidelines/"
                }
            ]
        },
        adult: {
            disclaimer:
                "64% of cats seen at vet clinics have dental issues, and over 60% are overweight or obese. Dental cleanings protect against periodontal disease, wellness exams catch weight and kidney problems, and blood tests screen for diabetes and kidney disease.",
            sources: [
                {
                    label: "Banfield 2024 (64% of cats have dental issues)",
                    url: "https://www.prnewswire.com/news-releases/state-of-pet-dental-health-significant-majority-of-us-dogs-and-cats-have-oral-health-issues-302063737.html"
                },
                {
                    label: "APOP 2022 (61% of cats overweight/obese)",
                    url: "https://www.petobesityprevention.org/2022"
                },
                {
                    label: "RVC VetCompass (feline dental disease)",
                    url: "https://www.rvc.ac.uk/vetcompass/news/the-uk-s-largest-ever-feline-dental-disease-study-identifies-age-and-breed-as-biggest-risk-factors"
                }
            ]
        }
    },
    "Domestic Mediumhair": {
        puppy: {
            disclaimer:
                "Spaying/neutering in the first year helps prevent obesity and reproductive cancers. Core FVRCP vaccines are essential for kittens—most infectious diseases are more prevalent in cats under 6 months—and deworming addresses intestinal parasites that are common in young cats.",
            sources: [
                {
                    label: "APOP 2022 (61% of cats overweight/obese)",
                    url: "https://www.petobesityprevention.org/2022"
                },
                {
                    label: "AAHA/AAFP 2020 Feline Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2020-aahaaafp-feline-vaccination-guidelines/"
                },
                {
                    label: "CAPC (fecal testing guidelines)",
                    url: "https://capcvet.org/guidelines/general-guidelines/"
                }
            ]
        },
        adult: {
            disclaimer:
                "Mixed-breed cats are prone to dental disease, obesity, and kidney problems. Dental cleanings prevent periodontal disease linked to heart issues, wellness exams monitor weight, and blood tests catch kidney disease and diabetes early—especially important as cats age.",
            sources: [
                {
                    label: "Banfield 2024 (64% of cats have dental issues)",
                    url: "https://www.prnewswire.com/news-releases/state-of-pet-dental-health-significant-majority-of-us-dogs-and-cats-have-oral-health-issues-302063737.html"
                },
                {
                    label: "APOP 2022 (61% of cats overweight/obese)",
                    url: "https://www.petobesityprevention.org/2022"
                },
                {
                    label: "Morris Animal Foundation (feline kidney disease)",
                    url: "https://www.morrisanimalfoundation.org/article/cat-health-disease"
                }
            ]
        }
    },
    "Domestic Longhair": {
        puppy: {
            disclaimer:
                "Longhaired cats are twice as likely to develop hairball-related GI issues, making early health baselines important. Spaying/neutering is recommended in year one, core FVRCP vaccines protect against serious diseases, and fecal tests catch parasites that can worsen GI complications.",
            sources: [
                {
                    label: "PMC (longhaired cats 2x hairball incidence)",
                    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10816490/"
                },
                {
                    label: "AAHA/AAFP 2020 Feline Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2020-aahaaafp-feline-vaccination-guidelines/"
                },
                {
                    label: "CAPC (fecal testing guidelines)",
                    url: "https://capcvet.org/guidelines/general-guidelines/"
                }
            ]
        },
        adult: {
            disclaimer:
                "Longhaired cats are twice as likely to develop hairball-related GI complications and share the same high rates of dental disease and obesity as all domestic cats. Wellness exams monitor weight and GI health, and urinalysis screens for kidney disease that commonly affects cats with age.",
            sources: [
                {
                    label: "PMC (longhaired cats 2x hairball incidence)",
                    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10816490/"
                },
                {
                    label: "Banfield 2024 (64% of cats have dental issues)",
                    url: "https://www.prnewswire.com/news-releases/state-of-pet-dental-health-significant-majority-of-us-dogs-and-cats-have-oral-health-issues-302063737.html"
                },
                {
                    label: "Morris Animal Foundation (feline kidney disease)",
                    url: "https://www.morrisanimalfoundation.org/article/cat-health-disease"
                }
            ]
        }
    },
    "American Shorthair": {
        puppy: {
            disclaimer:
                "American Shorthairs are predisposed to hypertrophic cardiomyopathy (HCM), and early health setup matters. Spaying/neutering is recommended in year one, core FVRCP vaccines protect against serious diseases, and FeLV vaccination is a core vaccine for cats under 1 year old.",
            sources: [
                {
                    label: "Cornell Veterinary (HCM breed predisposition)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/cornell-feline-health-center/health-information/feline-health-topics/hypertrophic-cardiomyopathy"
                },
                {
                    label: "AAHA/AAFP 2020 Feline Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2020-aahaaafp-feline-vaccination-guidelines"
                },
                {
                    label: "VCA Hospitals (HCM in cats)",
                    url: "https://vcahospitals.com/know-your-pet/heart-disease-cardiomyopathy-in-cats"
                }
            ]
        },
        adult: {
            disclaimer:
                "American Shorthairs are predisposed to hypertrophic cardiomyopathy and obesity-related diabetes. Dental cleanings prevent periodontal disease, blood tests help detect heart and metabolic issues early, and urinalysis screens for kidney disease and diabetes.",
            sources: [
                {
                    label: "Cornell Veterinary (HCM breed predisposition)",
                    url: "https://www.vet.cornell.edu/departments-centers-and-institutes/cornell-feline-health-center/health-information/feline-health-topics/hypertrophic-cardiomyopathy"
                },
                {
                    label: "VCA Hospitals (HCM in cats)",
                    url: "https://vcahospitals.com/know-your-pet/heart-disease-cardiomyopathy-in-cats"
                },
                {
                    label: "Banfield 2024 (64% of cats have dental issues)",
                    url: "https://www.prnewswire.com/news-releases/state-of-pet-dental-health-significant-majority-of-us-dogs-and-cats-have-oral-health-issues-302063737.html"
                }
            ]
        }
    },
    "Mixed Cat": {
        puppy: {
            disclaimer:
                "Over 60% of U.S. cats are overweight, and spaying/neutering in the first year helps prevent obesity and reproductive cancers. Core FVRCP vaccines are essential since most infectious diseases are more prevalent in kittens, and deworming addresses parasites common in young cats.",
            sources: [
                {
                    label: "APOP 2022 (61% of cats overweight/obese)",
                    url: "https://www.petobesityprevention.org/2022"
                },
                {
                    label: "AAHA/AAFP 2020 Feline Vaccination Guidelines",
                    url: "https://www.aaha.org/resources/2020-aahaaafp-feline-vaccination-guidelines/"
                },
                {
                    label: "CAPC (deworming guidelines)",
                    url: "https://capcvet.org/guidelines/general-guidelines/"
                }
            ]
        },
        adult: {
            disclaimer:
                "64% of cats seen at vet clinics have dental issues, and over 60% are overweight or obese. Dental cleanings prevent periodontal disease, blood tests screen for kidney disease and diabetes, and wellness exams monitor weight and catch problems before symptoms appear.",
            sources: [
                {
                    label: "Banfield 2024 (64% of cats have dental issues)",
                    url: "https://www.prnewswire.com/news-releases/state-of-pet-dental-health-significant-majority-of-us-dogs-and-cats-have-oral-health-issues-302063737.html"
                },
                {
                    label: "APOP 2022 (61% of cats overweight/obese)",
                    url: "https://www.petobesityprevention.org/2022"
                },
                {
                    label: "PMC (cat obesity epidemiology)",
                    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC11577473/"
                }
            ]
        }
    }
} as const;
